import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconListCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M13.4925 1.66699H6.50833C3.975 1.66699 2.5 3.15033 2.5 5.69199V14.3003C2.5 16.8837 3.975 18.3337 6.50833 18.3337H13.4925C16.0667 18.3337 17.5 16.8837 17.5 14.3003V5.69199C17.5 3.15033 16.0667 1.66699 13.4925 1.66699Z"
        fill="#BBBBBC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73379 5.54199V5.55033C6.37462 5.55033 6.08379 5.84199 6.08379 6.20033C6.08379 6.55866 6.37462 6.85033 6.73379 6.85033H9.22462C9.58379 6.85033 9.87546 6.55866 9.87546 6.19116C9.87546 5.83366 9.58379 5.54199 9.22462 5.54199H6.73379ZM13.2671 10.617H6.73379C6.37462 10.617 6.08379 10.3253 6.08379 9.96699C6.08379 9.60866 6.37462 9.31616 6.73379 9.31616H13.2671C13.6255 9.31616 13.9171 9.60866 13.9171 9.96699C13.9171 10.3253 13.6255 10.617 13.2671 10.617ZM13.2671 14.4253H6.73379C6.48379 14.4587 6.24212 14.3337 6.10879 14.1253C5.97546 13.9087 5.97546 13.6337 6.10879 13.4253C6.24212 13.2087 6.48379 13.092 6.73379 13.117H13.2671C13.5996 13.1503 13.8505 13.4337 13.8505 13.7753C13.8505 14.1078 13.5996 14.392 13.2671 14.4253Z"
        fill="#262626"
      />
    </Icon>
  );
};

export default IconListCalendar;
